// extracted by mini-css-extract-plugin
export default {"modal":"Steps_modal__7O3Ii","modalSteps":"Steps_modalSteps__e3izk"};